import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts, deleteProduct } from '../services/api';

const getImageSrc = (url) => {
  if (!url) return '/placeholder.jpg';
  return url;
};

export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = () => {
    getProducts()
      .then((data) => setProducts(data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا المنتج؟')) {
      await deleteProduct(id);
      fetchProducts();
    }
  };

  if (loading)
    return <p className="text-center py-10 text-neutral-400">جار التحميل...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl font-black text-white">
          المنتجات ({products.length})
        </h2>
        <Link
          to="/products/add"
          className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-700 transition"
        >
          + إضافة منتج
        </Link>
      </div>
      <div className="bg-neutral-950 rounded-xl border border-neutral-800 overflow-x-auto">
        <table className="w-full text-right">
          <thead className="bg-neutral-900 text-white">
            <tr>
              <th className="p-4">الصورة</th>
              <th className="p-4">الاسم</th>
              <th className="p-4">الفئة</th>
              <th className="p-4">السعر</th>
              <th className="p-4">المخزون</th>
              <th className="p-4">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr
                key={p.id}
                className="border-b border-neutral-800 hover:bg-neutral-900/50"
              >
                <td className="p-4">
                  <img
                    src={getImageSrc(p.image_url)}
                    alt={p.name}
                    className="w-12 h-12 object-cover rounded-lg"
                  />
                </td>
                <td className="p-4 font-medium text-white">{p.name}</td>
                <td className="p-4 text-neutral-400">
                  {p.category_ar || p.category}
                </td>
                <td className="p-4 text-white">{p.price} شيكل</td>
                <td className="p-4">
                  <span
                    className={
                      p.stock > 0
                        ? 'text-green-400 font-bold'
                        : 'text-red-500 font-bold'
                    }
                  >
                    {p.stock > 0 ? 'متوفر' : 'نفذ'}
                  </span>
                </td>
                <td className="p-4 flex gap-2">
                  <Link
                    to={`/products/edit/${p.id}`}
                    className="bg-neutral-800 text-white px-3 py-1 rounded text-sm hover:bg-neutral-700"
                  >
                    تعديل
                  </Link>
                  <button
                    onClick={() => handleDelete(p.id)}
                    className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}